import { isSameDay, startOfDay } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

export const isTodayByTimezone = (date: Date, timezone: string) => {
  const now = Date.now();
  const nowInTimezone = utcToZonedTime(now, timezone);
  const startOfDayInTimezone = startOfDay(date);

  return isSameDay(startOfDayInTimezone, nowInTimezone);
};
